var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 9.85938L2.03125 6.45312H8.76562C8.46354 5.75521 7.98958 5.19792 7.34375 4.78125C6.70833 4.35417 5.94271 4.14062 5.04688 4.14062H0.78125L2.03125 0.734375H18.6406L17.3906 4.14062H13.3906C13.5469 4.24479 13.6979 4.39062 13.8438 4.57812C13.9896 4.76562 14.1198 4.96875 14.2344 5.1875C14.349 5.40625 14.4427 5.63021 14.5156 5.85938C14.5885 6.08854 14.6354 6.28646 14.6562 6.45312H18.6406L17.3906 9.85938H14.375C14.1771 10.5052 13.875 11.1094 13.4688 11.6719C13.0729 12.224 12.5833 12.724 12 13.1719C11.4271 13.6094 10.776 13.9896 10.0469 14.3125C9.31771 14.625 8.53125 14.8646 7.6875 15.0312L17.4219 24H10.5625L1.45312 15.4688V12.1562H4.54688C5.05729 12.1562 5.52604 12.0938 5.95312 11.9688C6.39062 11.8333 6.77604 11.6615 7.10938 11.4531C7.45312 11.2344 7.74479 10.9896 7.98438 10.7188C8.23438 10.4375 8.42708 10.151 8.5625 9.85938H0.78125Z",
    fill: "url(#paint0_linear_3821_13709)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3821_13709",
    x1: 21,
    y1: 11.5,
    x2: -2,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF864C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.893c2c77dffc8e9239cd9f2511e00b9a.svg";
export { ForwardRef as ReactComponent };